export default __webpack_public_path__ + "static/media/s.fc8fb37e.svg";